import { FieldWeb } from 'app/shared/model/item.model';

export abstract class FormItemBaseChangeDetector {
  abstract hasChanged(newItem: FieldWeb, oldItem: FieldWeb): boolean;
}
